// extracted by mini-css-extract-plugin
export var table = "_483eb85fb380103c5d199ceaf4ab6f21-css";
export var numberCell = "_72f48b7e72c14d79ac61f97c40aef85e-css";